module.exports = __webpack_public_path__ + "img/12.879c625d.jpg";